import { f as functionBindNative } from './function-bind-native.js';

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

export { functionUncurryThis as f };
//# sourceMappingURL=function-uncurry-this.js.map
